import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumSortDirection } from '@hooks/useRequest';
import { AtividadeModal } from '@mod/Atividade/AtividadeModal';
import { ICliente } from '@model/Cliente';
import { useRemetenteWhatsappCombo } from '@model/RemetenteWhatsapp';
import { IClienteFilter, useClienteService } from '@services/ClienteService';
import React from 'react';
import { ClienteFilter } from './ClienteFilter';
import { ClienteTable } from './ClienteTable';
import { EnumClienteStatus } from '@model/ClienteStatus';

export type ClienteProps = {
}

export function Cliente (props: ClienteProps) {
    const data = useData<ICliente, IClienteFilter>({
        filter: {
            clienteId: useField(),
            nome: useField(),
            cpf: useField(),
            whatsappEnvio: useField(),
            clienteStatus: useField(EnumClienteStatus.Ativo)
        },

        sortField: {
            name: "nome",
            direction: EnumSortDirection.Asc
        }
    })

    const loading = useLoading();
    const message = useMessage();
    const clienteService = useClienteService();
    const atividadeModal = useModalWindow();
    const remetenteWhatsappCombo = useRemetenteWhatsappCombo();

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            clienteService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        remetenteWhatsappCombo.loadOptions();
    })

    return (
        <React.Fragment>
            <Main>
                <PageTitle>
                    <PageTitleText text="Clientes" />
                </PageTitle>

                <PageContent>
                    <ClienteFilter
                        filter={data.filter}
                        isLoading={loading.isLoading}
                        remetenteWhatsappCombo={remetenteWhatsappCombo}
                    />
                    
                    <ClienteTable 
                        data={data}
                        isLoading={loading.isLoading}
                        atividadeModal={atividadeModal}
                    />
                </PageContent>
            </Main>

            {
                data.focusedRow !== undefined && (
                    <AtividadeModal 
                        chaves={{
                            clienteId: data.focusedRow.clienteId
                        }}
                        entidade="cliente"
                        modal={atividadeModal}
                    />
                )
            }
        </React.Fragment>
    )
}